import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import { getAuth, signOut } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs, addDoc, updateDoc, doc, deleteDoc, getDoc, orderBy, limit, serverTimestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, listAll, getDownloadURL } from "firebase/storage";
import './corporate.css';
import emailjs from "emailjs-com";
import { db, storage } from "../LoginComp/firebase"; 
import { v4 as uuidv4 } from "uuid"; // Import uuid for generating unique IDs
import * as XLSX from "xlsx";


import { QRCodeCanvas } from "qrcode.react";
import { QRCodeSVG } from "qrcode.react";
import { saveAs } from 'file-saver';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';



import { motion } from "framer-motion";  
import { FaUsers, FaChalkboardTeacher, FaLayerGroup } from "react-icons/fa";  

import { FaFilter } from "react-icons/fa";




const animatedComponents = makeAnimated();


const Corporate = () => {
  // Common states
  const [selectedOption, setSelectedOption] = useState("home");
  const [userDetails, setUserDetails] = useState(null);
  const auth = getAuth();
  const navigate = useNavigate();
  const db = getFirestore();
  const [messageType, setMessageType] = useState("inquiry");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [lecturerEmail, setLecturerEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [assignments, setAssignments] = useState([]);
  const qrRef = useRef();

  // Student management states
  const [students, setStudents] = useState([]);
  const [isAddingStudent, setIsAddingStudent] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [backgroundImagePreview, setBackgroundImagePreview] = useState(null);
  const [studentSearchTerm, setStudentSearchTerm] = useState("");




//student payments analysis report
const [showFinancialOverview, setShowFinancialOverview] = useState(false);
const [activeFinanceTab, setActiveFinanceTab] = useState('overview');
const [payments, setPayments] = useState([]);




//sms broadcast
const [sendTo, setSendTo] = useState('class'); // 'class' or 'individual'
const [selectedClass, setSelectedClass] = useState('');
const [studentId, setStudentId] = useState('');
const [phoneNumber, setPhoneNumber] = useState('');



//attendance 
  const [records, setRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [search, setSearch] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [paymentFilter, setPaymentFilter] = useState("All Payments");


  // Student form state
  const [studentFormData, setStudentFormData] = useState({
    sid: "",
    name: "",
    age: 0,
    phone: "",
    address: "",
    email: "",
    dateOfBirth: "",
    paymentMethod: "Monthly",
    notes: ["", ""],
    swimHours: 0,
    classes: [],
    imageUrl: "",
    backgroundImageUrl: ""
  });

  // Class management states
  const [classes, setClasses] = useState([]);
  const [isAddingClass, setIsAddingClass] = useState(false);
  const [classSearchTerm, setClassSearchTerm] = useState("");
  const [editClassId, setEditClassId] = useState(null);
  
  // Class form state
  const [classFormData, setClassFormData] = useState({
    classId: "",
    name: "",
    grade: 0,
    subject: "",
    teacherName: "default",
    teacherPhone: "",
    teacherEmail: "default@gmail.com",
    fees: 0
  });

  // Stats states


  // Logout function
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      // Fetch students
      const studentsSnapshot = await getDocs(collection(db, "students"));
      const studentsData = studentsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setStudents(studentsData);
      setStudentCount(studentsData.length);

      // Fetch classes
      const classesSnapshot = await getDocs(collection(db, "classes"));
      const classesData = classesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        value: doc.id,
        label: `${doc.data().classId} - ${doc.data().subject}`
      }));
      setClasses(classesData);
      setClassCount(classesData.length);
    };
    fetchData();
  }, [db]);

  // Student handlers
  const handleStudentInputChange = (e) => {
    const { name, value } = e.target;
    setStudentFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleNoteChange = (index, value) => {
    const newNotes = [...studentFormData.notes];
    newNotes[index] = value;
    setStudentFormData(prev => ({ ...prev, notes: newNotes }));
  };

  const handleStudentClassChange = (selectedOptions) => {
    setStudentFormData(prev => ({
      ...prev,
      classes: selectedOptions.map(option => option.label)
    }));
  };

  const handleImageUpload = async (e, isBackground = false) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      isBackground 
        ? setBackgroundImagePreview(reader.result)
        : setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);

    const storageRef = ref(storage, `${isBackground ? 'backgrounds' : 'profiles'}/${file.name}`);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);

    setStudentFormData(prev => ({
      ...prev,
      [isBackground ? 'backgroundImageUrl' : 'imageUrl']: downloadURL
    }));
  };

  const generateStudentId = () => {
    const prefix = "CO";
    const year = new Date().getFullYear();
    const month = (new Date().getMonth() + 1).toString().padStart(2, '0');
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    return `${prefix}-${year}-${month}-${randomNum}`;
  };

  const handleStudentSubmit = async (e) => {
    e.preventDefault();
    
    if (!studentFormData.sid) {
      studentFormData.sid = generateStudentId();
    }

    try {
      if (isEditing && selectedStudent) {
        await updateDoc(doc(db, "students", selectedStudent.id), studentFormData);
      } else {
        await addDoc(collection(db, "students"), studentFormData);
      }

      const querySnapshot = await getDocs(collection(db, "students"));
      const studentsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setStudents(studentsData);
      setStudentCount(studentsData.length);

      setIsAddingStudent(false);
      setIsEditing(false);
      setSelectedStudent(null);
      setStudentFormData({
        sid: "",
        name: "",
        age: 0,
        phone: "",
        address: "",
        email: "",
        dateOfBirth: "",
        paymentMethod: "Monthly",
        notes: ["", ""],
        swimHours: 0,
        classes: [],
        imageUrl: "",
        backgroundImageUrl: ""
      });
      setImagePreview(null);
      setBackgroundImagePreview(null);
    } catch (error) {
      console.error("Error saving student:", error);
    }
  };

  const handleStudentEdit = (student) => {
    setSelectedStudent(student);
    setIsEditing(true);
    setIsAddingStudent(true);
    setStudentFormData({
      sid: student.sid,
      name: student.name,
      age: student.age,
      phone: student.phone,
      address: student.address,
      email: student.email,
      dateOfBirth: student.dateOfBirth,
      paymentMethod: student.paymentMethod || "Monthly",
      notes: student.notes || ["", ""],
      swimHours: student.swimHours || 0,
      classes: student.classes || [],
      imageUrl: student.imageUrl || "",
      backgroundImageUrl: student.backgroundImageUrl || ""
    });
    if (student.imageUrl) setImagePreview(student.imageUrl);
    if (student.backgroundImageUrl) setBackgroundImagePreview(student.backgroundImageUrl);
  };

  const handleViewProfile = (student) => {
    setSelectedStudent(student);
  };

  const handleStudentDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this student?")) {
      try {
        await deleteDoc(doc(db, "students", id));
        const updatedStudents = students.filter(student => student.id !== id);
        setStudents(updatedStudents);
        setStudentCount(updatedStudents.length);
      } catch (error) {
        console.error("Error deleting student:", error);
      }
    }
  };

  const handleStudentExport = () => {
    const headers = ["SID", "Name", "Age", "Phone", "Classes"];
    const csvContent = [
      headers.join(","),
      ...students.map(student => [
        student.sid,
        `"${student.name}"`,
        student.age,
        student.phone,
        `"${student.classes.join(", ")}"`
      ].join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "students_export.csv");
  };

  const filteredStudents = students.filter(student => 
    student.sid.toLowerCase().includes(studentSearchTerm.toLowerCase()) || 
    student.name.toLowerCase().includes(studentSearchTerm.toLowerCase())
  );

  // Class handlers
  const handleClassInputChange = (e) => {
    const { name, value } = e.target;
    setClassFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAddClass = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "classes"), classFormData);
      setIsAddingClass(false);
      setClassFormData({
        classId: "",
        name: "",
        grade: 0,
        subject: "",
        teacherName: "default",
        teacherPhone: "",
        teacherEmail: "default@gmail.com",
        fees: 0
      });
      
      const querySnapshot = await getDocs(collection(db, "classes"));
      const classesData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setClasses(classesData);
      setClassCount(classesData.length);
    } catch (error) {
      console.error("Error adding class:", error);
    }
  };

  const handleClassEdit = (classItem) => {
    setEditClassId(classItem.id);
    setClassFormData({
      classId: classItem.classId,
      name: classItem.name,
      grade: classItem.grade,
      subject: classItem.subject,
      teacherName: classItem.teacherName,
      teacherPhone: classItem.teacherPhone,
      teacherEmail: classItem.teacherEmail,
      fees: classItem.fees
    });
  };

  const handleUpdateClass = async (e) => {
    e.preventDefault();
    try {
      await updateDoc(doc(db, "classes", editClassId), classFormData);
      setEditClassId(null);
      
      const querySnapshot = await getDocs(collection(db, "classes"));
      const classesData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setClasses(classesData);
      setClassCount(classesData.length);
    } catch (error) {
      console.error("Error updating class:", error);
    }
  };

  const handleClassDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this class?")) {
      try {
        await deleteDoc(doc(db, "classes", id));
        const updatedClasses = classes.filter(classItem => classItem.id !== id);
        setClasses(updatedClasses);
        setClassCount(updatedClasses.length);
      } catch (error) {
        console.error("Error deleting class:", error);
      }
    }
  };

  const filteredClasses = classes.filter(classItem => 
    classItem.classId.toLowerCase().includes(classSearchTerm.toLowerCase()) || 
    classItem.subject.toLowerCase().includes(classSearchTerm.toLowerCase())
  );

  // Animation variants










  



//dashboard statistics
 const [studentCount, setStudentCount] = useState(0);
  const [classCount, setClassCount] = useState(0);
  const [batchCount, setBatchCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const studentsSnap = await getDocs(collection(db, "students"));
        const classesSnap = await getDocs(collection(db, "classes"));

        setStudentCount(studentsSnap.size);
        setClassCount(classesSnap.size);

        // Example: if "batches" is also a collection
        const batchesSnap = await getDocs(collection(db, "batches"));
        setBatchCount(batchesSnap.size);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, []);

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    hover: { scale: 1.05, rotate: 1 }
  };




//DOWNLOAD QR Code

  const downloadQRCode = () => {
    const svg = qrRef.current.querySelector("svg");
    const serializer = new XMLSerializer();
    const svgStr = serializer.serializeToString(svg);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img = new Image();
    const svgBlob = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);

      const pngUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `${studentFormData.sid}.png`;
      downloadLink.click();
    };

    img.src = url;
  };




  //student payments
// Add these state variables at the top with your other state declarations
const [paymentFormData, setPaymentFormData] = useState({
  studentId: "",
  studentName: "",
  paymentMethod: "Monthly",
  amount: "",
  paymentMonth: "",
  selectedClass: ""
});
const [lastPaymentStatus, setLastPaymentStatus] = useState("Not paid");
const [enrolledClasses, setEnrolledClasses] = useState([]);

// Add this useEffect for initial month setup
useEffect(() => {
  const currentMonth = new Date().toLocaleString("default", { month: "long" });
  setPaymentFormData(prev => ({
    ...prev,
    paymentMonth: currentMonth
  }));
}, []);

// Payment handler function
const handleStudentPayment = async (studentId) => {
  try {
    // Fetch student data
    const studentRef = doc(db, "students", studentId);
    const studentSnap = await getDoc(studentRef);
    
    if (studentSnap.exists()) {
      const studentData = studentSnap.data();
      
      // Set payment form data
      setPaymentFormData({
        studentId: studentData.sid,
        studentName: studentData.name,
        paymentMethod: "Monthly",
        amount: "",
        paymentMonth: new Date().toLocaleString("default", { month: "long" }),
        selectedClass: ""
      });

      // Set enrolled classes
      setEnrolledClasses(studentData.classes || []);

      // Check last payment status
      const paymentsRef = collection(db, "studentpayments");
      const q = query(
        paymentsRef,
        where("studentId", "==", studentData.sid),
        orderBy("createdAt", "desc"),
        limit(1)
      );
      
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const lastPayment = snapshot.docs[0].data();
        const prevMonth = new Date();
        prevMonth.setMonth(prevMonth.getMonth() - 1);
        const prevMonthName = prevMonth.toLocaleString("default", { month: "long" });
        
        setLastPaymentStatus(lastPayment.paymentMonth === prevMonthName ? "Paid" : "Not paid");
      } else {
        setLastPaymentStatus("Not paid");
      }
    }
  } catch (error) {
    console.error("Error fetching student data:", error);
  }
};

// Payment submission handler
const handlePaymentSubmit = async () => {
  if (!paymentFormData.amount || !paymentFormData.selectedClass) {
    alert("Please enter amount and select class");
    return;
  }

  try {
    await addDoc(collection(db, "studentpayments"), {
      studentId: paymentFormData.studentId,
      studentName: paymentFormData.studentName,
      classId: paymentFormData.selectedClass,
      paymentMethod: paymentFormData.paymentMethod,
      paymentMonth: paymentFormData.paymentMonth,
      amount: Number(paymentFormData.amount),
      createdAt: serverTimestamp(),
    });

    alert("Payment saved successfully!");
    // Refresh payment status
    handleStudentPayment(selectedStudent?.id);
  } catch (error) {
    console.error("Error saving payment:", error);
    alert("Failed to save payment");
  }
};

const [isPaymentOpen, setIsPaymentOpen] = useState(false);

//



  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "studentpayments"));
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPayments(data);
      } catch (error) {
        console.error("Error fetching payments:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);








//student message broadcast system
// Fetch classes for the current user
useEffect(() => {
  const fetchClasses = async () => {
    const classesSnapshot = await getDocs(collection(db, "classes"));
    const classesData = classesSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setClasses(classesData);
  };
  fetchClasses();
}, []);

// Handle sending to class
const handleSendToClass = async () => {
  if (!selectedClass || !message) {
    alert("Please select a class and enter a message");
    return;
  }
  
  try {
    // Implement your SMS sending logic here
    console.log(`Sending to class ${selectedClass}: ${message}`);
    alert("SMS sent successfully to class!");
    setMessage("");
  } catch (error) {
    console.error("Error sending SMS:", error);
    alert("Failed to send SMS");
  }
};

// Handle sending to individual
const handleSendToIndividual = async () => {
  if (!studentId || !message) {
    alert("Please enter student ID and message");
    return;
  }
  
  try {
    // Implement your SMS sending logic here
    console.log(`Sending to student ${studentId}: ${message}`);
    alert("SMS sent successfully to individual!");
    setMessage("");
    setStudentId("");
  } catch (error) {
    console.error("Error sending SMS:", error);
    alert("Failed to send SMS");
  }
};










  // Fetch attendance data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "attendance"));
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setRecords(data);
        setFilteredRecords(data);
      } catch (error) {
        console.error("Error fetching attendance:", error);
      }
    };
    fetchData();
  }, []);

  // Handle filtering
  useEffect(() => {
    let filtered = [...records];

    if (search) {
      filtered = filtered.filter(
        (rec) =>
          rec.studentId.toLowerCase().includes(search.toLowerCase()) ||
          rec.studentName.toLowerCase().includes(search.toLowerCase()) ||
          rec.className.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (dateFilter) {
      filtered = filtered.filter((rec) => {
        const recordDate = new Date(rec.timestamp.toDate());
        const selectedDate = new Date(dateFilter);
        return (
          recordDate.toDateString() === selectedDate.toDateString()
        );
      });
    }

    if (paymentFilter !== "All Payments") {
      filtered = filtered.filter((rec) => rec.paymentStatus === paymentFilter);
    }

    setFilteredRecords(filtered);
  }, [search, dateFilter, paymentFilter, records]);

  // Export to Excel
  // const exportToExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(filteredRecords);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Attendance");
  //   XLSX.writeFile(wb, "attendance_records.xlsx");
  // };

const exportToExcel = () => {
  // Define the desired column order
  const orderedData = filteredRecords.map((rec) => ({
    "Student ID": rec.studentId,
    "Name": rec.studentName,
    "Date": rec.timestamp.toDate().toLocaleDateString(), // Format as needed
    "Class": rec.className,
    "Status": rec.paymentStatus,
  }));

  const ws = XLSX.utils.json_to_sheet(orderedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Attendance");
  XLSX.writeFile(wb, "attendance_records.xlsx");
};








  return (
    <div className="corporate-dashboard-container">
      {/* Left Sidebar */}
      <div className="corporate-sidebar">
        <h2 className="corporate-sidebar-title">Student Attendance Manage Panel</h2>
        <div className="corporate-sidebar-list">
          <li onClick={() => setSelectedOption("home")}>Home</li>
          <li onClick={() => setSelectedOption("manageStudents")}>Manage Student</li>
          <li onClick={() => setSelectedOption("manageClasses")}>Manage Classes</li>
          <li onClick={() => setSelectedOption("attendance")}>Attendance</li>
          {/* <li onClick={() => setSelectedOption("paymentAnalysis")}>Payment Records</li> */}
          <li onClick={() => setSelectedOption("smsBroadcast")}>Section Message</li>
          <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
      </div>

      {/* Main Panel */}
      <div className="corporate-panel">



{selectedOption === "home" && ( 
  <div className="home-section">
    <div className="stats-panel">

      <motion.div
        className="stat-card students-card"
        variants={cardVariants}
        initial="hidden"
        animate="visible"
      >
        <img src="/student.gif" alt="Students" className="stat-gif" />
        <h2>Total Students</h2>
        <p>{studentCount}</p>
      </motion.div>

      <motion.div
        className="stat-card classes-card"
        variants={cardVariants}
        initial="hidden"
        animate="visible"
      >
        <img src="/class.gif" alt="Classes" className="stat-gif" />
        <h2>Total Classes</h2>
        <p>{classCount}</p>
      </motion.div>

      <motion.div
        className="stat-card sms-card"
        variants={cardVariants}
        initial="hidden"
        animate="visible"
      >
        <img src="/sms.gif" alt="SMS Service" className="stat-gif" />
        <h2>SMS Service</h2>
        <p>Activated</p>
      </motion.div>

      <motion.div
        className="stat-card package-card"
        variants={cardVariants}
        initial="hidden"
        animate="visible"
      >
        <img src="/package.gif" alt="Package Duration" className="stat-gif" />
          <h2>Package Duration</h2>
          <p> &infin;</p>
      </motion.div>

    </div>
  </div>
)}





        {selectedOption === "manageStudents" && (
          <div className="management-system">
            {/* Student Management Panel */}
            <div className="student-container">
              <h1 className="student-title">Student Management</h1>
              <p className="student-subtitle">View, edit, and manage all student records.</p>
              
              <div className="controls-section">
                <div className="search-section">
                  <h3>Search by Student ID</h3>
                  <div className="search-container">
                    <input
                      type="text"
                      placeholder="Search by Student ID or Name"
                      value={studentSearchTerm}
                      onChange={(e) => setStudentSearchTerm(e.target.value)}
                      className="search-input"
                    />

<div class="filters">
  <span><i class="fa-solid fa-filter"></i> All Ages</span>
  <span><i class="fa-solid fa-filter"></i> All Classes</span>
</div>
                  </div>
                </div>
                
                <div className="action-buttons">
                  <button 
                    onClick={() => {
                      setIsAddingStudent(true);
                      setIsEditing(false);
                      setSelectedStudent(null);
                    }}
                    className="add-btn"
                  >
                    + Add Student
                  </button>
                  <button 
                    onClick={handleStudentExport}
                    className="export-btn"
                  >
                    Export
                  </button>
                </div>
              </div>
              
              <div className="table-container">
                <table className="students-table">
                  <thead>
                    <tr>
                      <th>Student ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Age</th>
                      <th>Phone No</th>
                      <th>Classes</th>
                      <th>Payment Method</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStudents.map((student) => (
                      <tr key={student.id}>
                        <td>{student.sid}</td>
                        <td>{student.email}</td>
                        <td>{student.name}</td>
                        <td>{student.age}</td>
                        <td>{student.phone}</td>
                      
                        <td className="classes-cell">
                          {student.classes.join(", ")}
                        </td>
                          <td>{student.paymentMethod}</td>
                        <td className="actions-cell">


                          <button 
                            onClick={() => handleViewProfile(student)}
                            className="profile-btn"
                          >
                          <span class="fa">&#xf007;</span>
                          </button>


                          <button 
                            onClick={() => handleStudentEdit(student)}
                            className="edit-btn"
                          >
                          <span>&#x270E;</span>
                          </button>


                          <button 
                            onClick={() => handleStudentDelete(student.id)}
                            className="delete-btn"
                          >
                           <span>&#x1F5D1;</span>
                          </button>


{/* <button 
  onClick={() => {
    setIsPaymentOpen(true);
    setPaymentFormData({
      studentId: student.sid,
      studentName: student.name,
      paymentMethod: student.paymentMethod || "Monthly",
      amount: "",
      paymentMonth: "",
      selectedClass: ""
    });
    setEnrolledClasses(student.classes || []);
  }} 
  className="payment-btn"
>
  <span>&#x1F4B5;</span>
</button> */}


                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            
            {/* Add/Edit Student Modal */}
            {isAddingStudent && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <div className="form-container">
                    <div className="form-panel">
                      <h2>{isEditing ? "Edit Student" : "Add Student"}</h2>
                      <form onSubmit={handleStudentSubmit}>
                  <div className="form-section">
                    <div className="form-group">
                      <label>Student ID:</label>
                      <input
                        type="text"
                        name="sid"
                        value={studentFormData.sid}
                        onChange={handleStudentInputChange}
                        placeholder="Leave blank to auto-generate"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Name:</label>
                      <input
                        type="text"
                        name="name"
                        value={studentFormData.name}
                        onChange={handleStudentInputChange}
                        placeholder="Enter full name"
                        required
                      />
                    </div>
                    
                    <div className="form-row">
                      <div className="form-group">
                        <label>Email:</label>
                        <input
                          type="email"
                          name="email"
                          value={studentFormData.email}
                          onChange={handleStudentInputChange}
                          placeholder="Enter email"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Age:</label>
                        <input
                          type="number"
                          name="age"
                          value={studentFormData.age}
                          onChange={handleStudentInputChange}
                          placeholder="Enter age"
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="form-group">
                      <label>Address:</label>
                      <textarea
                        name="address"
                        value={studentFormData.address}
                        onChange={handleStudentInputChange}
                        placeholder="Enter address"
                        rows="3"
                        required
                      />
                    </div>
                    
                    <div className="form-row">
                      <div className="form-group">
                        <label>Phone:</label>
                        <input
                          type="tel"
                          name="phone"
                          value={studentFormData.phone}
                          onChange={handleStudentInputChange}
                          placeholder="Enter phone number"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Date of Birth:</label>
                        <input
                          type="date"
                          name="dateOfBirth"
                          value={studentFormData.dateOfBirth}
                          onChange={handleStudentInputChange}
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="form-group">
                      <label>Payment Method:</label>
                      <select
                        name="paymentMethod"
                        value={studentFormData.paymentMethod}
                        onChange={handleStudentInputChange}
                      >
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Yearly">Yearly</option>
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label>Profile Image:</label>
                      <div className="file-upload">
                        <input
                          type="file"
                          id="imageUpload"
                          onChange={(e) => handleImageUpload(e, false)}
                          accept="image/*"
                        />
                        <label htmlFor="imageUpload">
                          {imagePreview ? "Change Image" : "Choose Image"}
                        </label>
                        {imagePreview && (
                          <div className="image-preview">
                            <img src={imagePreview} alt="Profile Preview" />
                          </div>
                        )}
                      </div>
                    </div>
                    
                    <div className="form-group">
                      <label>Select Classes:</label>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={classes}
                        value={classes.filter(option => 
                          studentFormData.classes.includes(option.label)
                        )}
                        onChange={handleStudentClassChange}
                        placeholder="Select classes..."
                      />
                    </div>
                    
   
                    <div className="form-group">
                      <label>Swim Hours:</label>
                      <input
                        type="number"
                        name="swimHours"
                        value={studentFormData.swimHours}
                        onChange={handleStudentInputChange}
                        placeholder="Enter swim hours"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Note 1:</label>
                      <input
                        type="text"
                        value={studentFormData.notes[0]}
                        onChange={(e) => handleNoteChange(0, e.target.value)}
                        placeholder="Enter note 1"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Note 2:</label>
                      <input
                        type="text"
                        value={studentFormData.notes[1]}
                        onChange={(e) => handleNoteChange(1, e.target.value)}
                        placeholder="Enter note 2"
                      />
                    </div>
                  </div>
                  
                  <div className="form-actions">
                    <button type="submit" className="submit-btn">
                      {isEditing ? "Update Student" : "Add Student"}
                    </button>
                    <button 
                      type="button" 
                      onClick={() => {
                        setIsAddingStudent(false);
                        setIsEditing(false);
                        setSelectedStudent(null);
                      }}
                      className="cancel-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
              
              <div className="details-panel">
                <div className="institute-info">
                  <h3>Eye Care Institute (pvt) Ltd</h3>
                  <div className="logo-upload">
                    {backgroundImagePreview ? (
                      <div className="background-preview">
                        <img src={backgroundImagePreview} alt="Background Preview" />
                      </div>
                    ) : (
                      <div className="background-upload">
                        <input
                          type="file"
                          id="backgroundUpload"
                          onChange={(e) => handleImageUpload(e, true)}
                          accept="image/*"
                        />
                        <label htmlFor="backgroundUpload">
                          Choose Background Image
                        </label>
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="steps-section">
                  <h4>Step 1</h4>
                  <p>Please fill all fields. Make sure to provide accurate information.</p>
                  
                  <h4>Step 2</h4>
                  <p>Generate QR Code</p>
                  
                  <h4>Step 3</h4>
                  <p>Download ID Card</p>
                  
                  <h4>Step 4</h4>
                  <p>Finalize submission</p>
                </div>
                
    {studentFormData.sid && (
        <div className="qr-section" ref={qrRef}>
          <QRCodeSVG
            value={studentFormData.sid}
            size={128}
            level="H"
            includeMargin={true}
          />
          <p>Student ID: {studentFormData.sid}</p>
          <button onClick={downloadQRCode}>Download QR Code</button>
        </div>
      )}
              </div>
            </div>
          </div>
        </div>
      )}
      

      {/* Student Profile Modal */}
      {selectedStudent && !isAddingStudent && (
        <div className="modal-overlay">
          <div className="profile-modal">
            <div className="profile-container">
              <div className="profile-info">
                <h2>Student Profile</h2>
                {selectedStudent.imageUrl && (
                  <div className="profile-image">
                    <img src={selectedStudent.imageUrl} alt="Profile" />
                  </div>
                )}
                
                <div className="profile-details">
                  <div className="detail-row">
                    <span className="detail-label">Student ID:</span>
                    <span className="detail-value">{selectedStudent.sid}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Name:</span>
                    <span className="detail-value">{selectedStudent.name}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Age:</span>
                    <span className="detail-value">{selectedStudent.age}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Email:</span>
                    <span className="detail-value">{selectedStudent.email}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Phone:</span>
                    <span className="detail-value">{selectedStudent.phone}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Address:</span>
                    <span className="detail-value">{selectedStudent.address}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Date of Birth:</span>
                    <span className="detail-value">{selectedStudent.dateOfBirth}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Payment Method:</span>
                    <span className="detail-value">{selectedStudent.paymentMethod}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Swim Hours:</span>
                    <span className="detail-value">{selectedStudent.swimHours}</span>
                  </div>
                  
                  {selectedStudent.notes && selectedStudent.notes[0] && (
                    <div className="detail-row">
                      <span className="detail-label">Note 1:</span>
                      <span className="detail-value">{selectedStudent.notes[0]}</span>
                    </div>
                  )}
                  
                  {selectedStudent.notes && selectedStudent.notes[1] && (
                    <div className="detail-row">
                      <span className="detail-label">Note 2:</span>
                      <span className="detail-value">{selectedStudent.notes[1]}</span>
                    </div>
                  )}
                </div>
                
                <div className="profile-classes">
                  <h4>Enrolled Classes:</h4>
                  <ul>
                    {selectedStudent.classes && selectedStudent.classes.map((cls, index) => (
                      <li key={index}>{cls}</li>
                    ))}
                  </ul>
                </div>
              </div>
              
              {/* <div className="student-attendance-info">
                <h2>Attendance Information</h2>
                <div className="student-attendance-stats">
                  <div className="student-stat-card">
                    <h3>Total Classes</h3>
                    <p>24</p>
                  </div>
                  <div className="student-stat-card">
                    <h3>Present</h3>
                    <p>20</p>
                  </div>
                  <div className="student-stat-card">
                    <h3>Absent</h3>
                    <p>4</p>
                  </div>
                  <div className="student-stat-card">
                    <h3>Attendance %</h3>
                    <p>83.33%</p>
                  </div>
                </div>


                
                <div className="attendance-history">
                  <h3>Recent Attendance</h3>
                  <table>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Class</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>2023-10-15</td>
                        <td>CO102-Optics</td>
                        <td className="present">Present</td>
                      </tr>
                      <tr>
                        <td>2023-10-14</td>
                        <td>CO101-General Science</td>
                        <td className="absent">Absent</td>
                      </tr>
                      <tr>
                        <td>2023-10-13</td>
                        <td>CO104-Understanding Prescription</td>
                        <td className="present">Present</td>
                      </tr>
                      <tr>
                        <td>2023-10-12</td>
                        <td>Ocular Pathology II</td>
                        <td className="present">Present</td>
                      </tr>
                      <tr>
                        <td>2023-10-11</td>
                        <td>Visual Optics</td>
                        <td className="present">Present</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> */}
            </div>
            
            <button 
              className="close-btn"
              onClick={() => setSelectedStudent(null)}
            >
             <span>&times;</span>
            </button>
          </div>
        </div>
      )}







      {/* Payment Records Modal */}
{isPaymentOpen && (
  <div className="payment-modal-overlay">
    <div className="payment-records-container">
      <h1 className="payment-records-title">Payment Records</h1>
      
      {paymentFormData.studentId ? (
<div className="payment-container">
  <h2>Make Monthly Payment</h2>

  <div className="payment-main">
    {/* Left - Form */}
    <div className="payment-form">
      {/* form groups here */}
      <div className="form-group">
        <label>Student ID</label>
        <input type="text" value={paymentFormData.studentId} readOnly />
      </div>

      <div className="form-group">
        <label>Student Name</label>
        <input type="text" value={paymentFormData.studentName} readOnly />
      </div>

      <div className="form-group">
        <label>Payment Method</label>
        <select 
          value={paymentFormData.paymentMethod}
          onChange={(e) => setPaymentFormData(prev => ({
            ...prev,
            paymentMethod: e.target.value
          }))}
        >
          <option value="Monthly">Monthly</option>
          <option value="Quarterly">Quarterly</option>
          <option value="Yearly">Yearly</option>
        </select>
      </div>

      <div className="form-group">
        <label>Amount (Rs.)</label>
        <input 
          type="number" 
          value={paymentFormData.amount}
          onChange={(e) => setPaymentFormData(prev => ({
            ...prev,
            amount: e.target.value
          }))}
          placeholder="Enter Amount"
        />
      </div>

      <div className="form-group">
        <label>Payment Month</label>
        <select 
          value={paymentFormData.paymentMonth}
          onChange={(e) => setPaymentFormData(prev => ({
            ...prev,
            paymentMonth: e.target.value
          }))}
        >
          {Array.from({ length: 12 }, (_, i) =>
            new Date(0, i).toLocaleString("default", { month: "long" })
          ).map((month) => (
            <option key={month} value={month}>{month}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Select Class</label>
        <select 
          value={paymentFormData.selectedClass}
          onChange={(e) => setPaymentFormData(prev => ({
            ...prev,
            selectedClass: e.target.value
          }))}
        >
          <option value="">Select a class</option>
          {enrolledClasses.map((className, index) => (
            <option key={index} value={className}>
              {className}
            </option>
          ))}
        </select>
      </div>

      <button onClick={handlePaymentSubmit} className="submit-payment-btn">
        Submit Monthly Payment
      </button>
    </div>

    {/* Right - Extra Info */}
    <div className="extra-right-panel">
      <div className="enrolled-classes">
        <h3>Enrolled Classes</h3>
        <ul>
          {enrolledClasses.map((className, index) => (
            <li key={index}>{className}</li>
          ))}
        </ul>
      </div>

      <div className="payment-info">
        <h3>Payment Information</h3>
        <p>Student ID: {paymentFormData.studentId}</p>
        <p>Payment Type: {paymentFormData.paymentMethod}</p>
        <p>Monthly payment will use the current month for record keeping.</p>
      </div>
    </div>
  </div>
</div>

      ) : (
        <p>Please select a student first by clicking the payment button</p>
      )}

      <button 
        className="close-btn"
        onClick={() => setIsPaymentOpen(false)}
      >
        <span>&times;</span>
      </button>
    </div>
  </div>
)}
    </div>























              )}

{/************************************************************************************************************************/} 
 {selectedOption === "manageClasses" && (
          <div className="management-system">
            <div className="class-container">
              <h1 className="class-title">Manage Classes</h1>
              <p className="class-subtitle">Manage your classes, teachers, and fees</p>
              
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Search by Class ID or Subject"
                  value={classSearchTerm}
                  onChange={(e) => setClassSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>
              
              <button 
                onClick={() => setIsAddingClass(true)}
                className="add-class-btn"
              >
                + Add New Class
              </button>
              
              <div className="table-container">
                <table className="classes-table">
                  <thead>
                    <tr>
                      <th>Class ID</th>
                      <th>Subject</th>
                      <th>Grade</th>
                      <th>Teacher's Name</th>
                      <th>Email</th>
                      <th>Phone No</th>
                      <th>Fees (SR)</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredClasses.map((classItem) => (
                      <tr key={classItem.id}>
                        <td>{classItem.classId}</td>
                        <td>{classItem.subject}</td>
                        <td>{classItem.grade}</td>
                        <td>{classItem.teacherName}</td>
                        <td>{classItem.teacherEmail}</td>
                        <td>{classItem.teacherPhone}</td>
                        <td>{classItem.fees}</td>
                        <td className="actions-cell">
                          <button 
                            onClick={() => handleClassEdit(classItem)}
                            className="edit-btn"
                          >
                            <span>&#x270E;</span>
                          </button>
                          <button 
                            onClick={() => handleClassDelete(classItem.id)}
                            className="delete-btn"
                          >
                            <span>&#x1F5D1;</span>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              {/* Add Class Modal */}
              {(isAddingClass || editClassId) && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <h2>{editClassId ? "Edit Class" : "Add a New Class"}</h2>
                    <form onSubmit={editClassId ? handleUpdateClass : handleAddClass}>
                  <div className="form-group">
                    <label>Class ID:</label>
                    <input
                      type="text"
                      name="classId"
                      value={classFormData.classId}
                      onChange={handleClassInputChange}
                      placeholder="Enter Class ID"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Subject:</label>
                    <input
                      type="text"
                      name="subject"
                      value={classFormData.subject}
                      onChange={handleClassInputChange}
                      placeholder="Enter Subject"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Grade:</label>
                    <input
                      type="number"
                      name="grade"
                      value={classFormData.grade}
                      onChange={handleClassInputChange}
                      placeholder="Enter Grade"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Teacher's name:</label>
                    <input
                      type="text"
                      name="teacherName"
                      value={classFormData.teacherName}
                      onChange={handleClassInputChange}
                      placeholder="Enter teacher's name"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Teacher's Phone:</label>
                    <input
                      type="tel"
                      name="teacherPhone"
                      value={classFormData.teacherPhone}
                      onChange={handleClassInputChange}
                      placeholder="Enter Phone number"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Teacher's Email:</label>
                    <input
                      type="email"
                      name="teacherEmail"
                      value={classFormData.teacherEmail}
                      onChange={handleClassInputChange}
                      placeholder="Enter Email"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Class Fees (SR):</label>
                    <input
                      type="number"
                      name="fees"
                      value={classFormData.fees}
                      onChange={handleClassInputChange}
                      placeholder="Enter Class fee"
                      required
                    />
                  </div>
                  
                  <div className="form-actions">
                    <button type="submit" className="submit-btn">
                      {editClassId ? "Update Class" : "Add Class"}
                    </button>
                    <button 
                      type="button" 
                      onClick={() => {
                        setIsAddingClass(false);
                        setEditClassId(null);
                      }}
                      className="cancel-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
        </div>
      )}
    </div>


{/************************************************************************************************************************/} 
{(selectedOption === "attendance" && 
<div className="attendance-records-container">
  <h1 className="attendance-records-header">Attendance Records</h1>
  <p className="attendance-records-subheader">
    View and manage student attendance and payment status
  </p>

  {/* Filters */}
  <div className="attendance-filter-container">
    <input
      type="text"
      placeholder="Student ID, Name, or Class"
      className="attendance-search-input"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />

    <input
      type="date"
      className="attendance-date-filter"
      value={dateFilter}
      onChange={(e) => setDateFilter(e.target.value)}
    />

    <select
      className="attendance-payment-select"
      value={paymentFilter}
      onChange={(e) => setPaymentFilter(e.target.value)}
    >
      <option value="All Payments">All Payments</option>
      <option value="Paid">Paid</option>
      <option value="Not Paid">Not Paid</option>
    </select>

    <button
      className="attendance-export-btn"
      onClick={exportToExcel}
    >
      Export to Excel
    </button>
  </div>

  {/* Table */}
  <div className="attendance-records-table-container">
    <table className="attendance-records-table">
      <thead>
        <tr>
          <th>Student ID</th>
          <th>Name</th>
          <th>Date</th>
          <th>Class</th>
          <th>Status</th>

        </tr>
      </thead>
      <tbody>
        {filteredRecords.map((rec) => (
          <tr key={rec.id}>
            <td>{rec.studentId}</td>
            <td>{rec.studentName}</td>
            <td>
              {rec.timestamp?.toDate().toLocaleString()}
            </td>
            <td>{rec.className}</td>
            <td>
              <span
                className={`attendance-status-badge ${
                  rec.status === "present"
                    ? "attendance-status-present"
                    : "attendance-status-absent"
                }`}
              >
                {rec.status}
              </span>
            </td>

            {/* <td>
              <span
                className={`attendance-status-badge ${
                  rec.paymentStatus === "Paid"
                    ? "attendance-payment-paid"
                    : "attendance-payment-unpaid"
                }`}
              >
                {rec.paymentStatus || "Not Paid"}
              </span>
            </td> */}

          </tr>
        ))}
        {filteredRecords.length === 0 && (
          <tr>
            <td colSpan="6" className="attendance-empty-state">
              No records found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>
    )}

{/************************************************************************************************************************/} 



{selectedOption === "paymentAnalysis" && (
    <div className="payment-analysis-container">
      {/* Payment Records Section */}
      <div className="payment-records-section">
        <h1 className="section-title">Payment Records</h1>
        <p className="section-subtitle">Manage and track student payments</p>

        {/* Filters Section */}
        <div className="filters-section">
          <h3>Filter Payments</h3>
          <div className="filter-grid">
            <div className="filter-group">
              <label>Student ID</label>
              <input type="text" placeholder="Enter Student ID" />
            </div>
            <div className="filter-group">
              <label>Month</label>
              <input type="text" placeholder="Enter Month" />
            </div>
            <div className="filter-group">
              <label>Class Name</label>
              <input type="text" placeholder="Enter Class Name" />
            </div>
            <div className="filter-group">
              <label>Payment Method</label>
              <select>
                <option>All Payment Methods</option>
                <option>Monthly</option>
                <option>Quarterly</option>
                <option>Yearly</option>
              </select>
            </div>
          </div>

          <div className="filter-actions">
            <button className="clear-filters-btn">Clear Filters</button>
            <button className="export-btn">Export to Excel</button>
            <button
              className="dashboard-btn"
              onClick={() => setShowFinancialOverview(true)}
            >
              Income Dashboard
            </button>
          </div>
        </div>

        {/* Payment Records Table */}
        <div className="records-summary">
          <p>
            Showing {loading ? "..." : payments.length} payment records
          </p>
        </div>

        <div className="payments-table-container">
          <table className="payments-table">
            <thead>
              <tr>
                <th>Student ID</th>
                <th>Name</th>
                <th>Amount</th>
                <th>Month</th>
                <th>Class</th>
                <th>Paid For</th>
                <th>Date</th>
                <th>Payment Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9">Loading...</td>
                </tr>
              ) : payments.length === 0 ? (
                <tr>
                  <td colSpan="9">No records found</td>
                </tr>
              ) : (
                payments.map((p) => (
                  <tr key={p.id}>
                    <td>{p.studentId}</td>
                    <td>{p.studentName}</td>
                    <td>{p.amount}</td>
                    <td>{p.paymentMonth}</td>
                    <td>{p.classId}</td>
                    <td>{p.paymentMethod}</td>
                    <td>
                      {p.createdAt?.toDate
                        ? p.createdAt.toDate().toLocaleString()
                        : ""}
                    </td>
                    <td className="paid-status">paid</td>
                    <td className="actions-cell">
                      <button className="edit-btn">Edit</button>
                      <button className="delete-btn">Delete</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Financial Overview Section */}
      {showFinancialOverview && (
        <div className="financial-overview-section">
          <div className="finance-tabs">
            <button
              className={activeFinanceTab === "overview" ? "active" : ""}
              onClick={() => setActiveFinanceTab("overview")}
            >
              Financial Overview
            </button>
            <button
              className={activeFinanceTab === "transactions" ? "active" : ""}
              onClick={() => setActiveFinanceTab("transactions")}
            >
              All Transactions
            </button>
            <button
              className={activeFinanceTab === "expenses" ? "active" : ""}
              onClick={() => setActiveFinanceTab("expenses")}
            >
              Expenses
            </button>
            <button
              className={activeFinanceTab === "income" ? "active" : ""}
              onClick={() => setActiveFinanceTab("income")}
            >
              Additional Income
            </button>
          </div>

          {/* Monthly Summary */}
          <div className="summary-section">
            <h3>Monthly Financial Summary</h3>
            <p>View income, expenses, and net income for a specific month</p>

            <div className="summary-controls">
              <div className="control-group">
                <label>Select Month</label>
                <select>
                  <option>Select a month</option>
                  {Array.from({ length: 12 }, (_, i) => {
                    const month = new Date(0, i).toLocaleString("default", {
                      month: "long",
                    });
                    return <option key={month}>{month}</option>;
                  })}
                </select>
              </div>

              <div className="control-group">
                <label>Select Year</label>
                <select>
                  <option>2025</option>
                  <option>2024</option>
                  <option>2023</option>
                </select>
              </div>

              <button className="calculate-btn">Calculate Monthly Summary</button>
            </div>
          </div>

          {/* Daily Summary */}
          <div className="summary-section">
            <h3>Daily Financial Summary</h3>
            <p>View income, expenses, and net income for a specific date</p>

            <div className="summary-controls">
              <div className="control-group">
                <label>Select Date</label>
                <input type="date" defaultValue="2025-08-18" />
              </div>

              <button className="calculate-btn">Calculate Daily Summary</button>
            </div>
          </div>

          <button
            className="close-dashboard-btn"
            onClick={() => setShowFinancialOverview(false)}
          >
            Close Dashboard
          </button>
        </div>
      )}
    </div>
)}

    
{/****************************************************************************************************************************************/}

  
{selectedOption === "smsBroadcast" && (
  <div className="sms-broadcast-container">
    <h1 className="sms-title">SMS Broadcast System</h1>
    <p className="sms-subtitle">Send messages to students and parents</p>
    
    <div className="sms-balance-container">
      <p><span className="balance-count">SMS Service</span></p>
    
    </div>
    
    <div className="sms-tabs">
      <button 
        className={`sms-tab ${sendTo === 'class' ? 'active' : ''}`}
        onClick={() => setSendTo('class')}
      >
        Send to Class
      </button>
      <button 
        className={`sms-tab ${sendTo === 'individual' ? 'active' : ''}`}
        onClick={() => setSendTo('individual')}
      >
        Send to Individual
      </button>
    </div>
    
    {sendTo === 'class' ? (
      <div className="sms-class-form">
        <div className="form-group">
          <label>Select Class</label>
          <select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
          >
            <option value="">Select a class --</option>
            {classes.map((classItem) => (
              <option key={classItem.id} value={classItem.id}>
                {classItem.classId} - {classItem.subject}
              </option>
            ))}
          </select>
        </div>
        
        <div className="form-group">
          <label>Message ({160 - message.length} characters remaining)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message here..."
            maxLength={160}
          />
        </div>
        
        <button 
          className="send-sms-btn"
          onClick={handleSendToClass}
        >
          Send to Class
        </button>
      </div>
    ) : (
      <div className="sms-individual-form">
        <div className="form-group">
          <label>Student ID</label>
          <input
            type="text"
            value={studentId}
            onChange={(e) => setStudentId(e.target.value)}
            placeholder="Enter student ID"
          />
          <p className="phone-status">
            {phoneNumber ? phoneNumber : "No phone number found"}
          </p>
        </div>
        
        <div className="form-group">
          <label>Message ({160 - message.length} characters remaining)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message here..."
            maxLength={160}
          />
        </div>
        
        <button 
          className="send-sms-btn"
          onClick={handleSendToIndividual}
        >
          Send to Individual
        </button>
      </div>
    )}
  </div>
)}
       





{/************************************************************************************************************************/} 



        </div>


  );
};

export default Corporate;
 